function htUpdateCountdown(el) {
  const deadline = new Date(el.dataset.deadline).getTime();
  const days = el.querySelector('[data-ht-countdown-days]');
  const hours = el.querySelector('[data-ht-countdown-hours]');
  const minutes = el.querySelector('[data-ht-countdown-minutes]');
  const seconds = el.querySelector('[data-ht-countdown-seconds]');
  const pad = (n) => String(n).padStart(2, '0');

  if (!deadline || Number.isNaN(deadline)) return;

  let remaining = Math.max(0, deadline - Date.now());
  const day_ms = 86400000;
  const hour_ms = 3600000;
  const minute_ms = 60000;

  const d = Math.floor(remaining / day_ms);
  remaining %= day_ms;
  const h = Math.floor(remaining / hour_ms);
  remaining %= hour_ms;
  const m = Math.floor(remaining / minute_ms);
  remaining %= minute_ms;
  const s = Math.floor(remaining / 1000);

  if (days) days.textContent = pad(d);
  if (hours) hours.textContent = pad(h);
  if (minutes) minutes.textContent = pad(m);
  if (seconds) seconds.textContent = pad(s);
}

document.querySelectorAll('[data-ht-countdown]').forEach((el) => {
  htUpdateCountdown(el);
  setInterval(() => htUpdateCountdown(el), 1000);
});
